import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import { SyncTargetCompaniesGetResponse } from "@/types/swagger";
import API from "@/api";

export interface ICompanyState {
  sync_target_id: number; // 同期対象ID
  sync_target_group_id: number; // 同期対象グループID
  company_id: number; // 会社ID（クライアントのリスト表示のValue値）
  company_name: string; // 会社名
  disp_sort: number; // 表示順
}

const initialState: ICompanyState[] = [];

@Module({
  name: "Companies",
  stateFactory: true,
  namespaced: true,
})
export class Companies extends VuexModule {
  private companies: ICompanyState[] = initialState;

  public get getCompanies() {
    return this.companies;
  }

  @Mutation
  private set(companies: ICompanyState[]) {
    this.companies = companies;
  }

  @Action({ rawError: true })
  public init() {
    this.set(initialState);
  }

  @Action({ rawError: true })
  public async fetchCompanies(userId: number) {
    const api = new API();
    const response: SyncTargetCompaniesGetResponse = await api.get(
      `/users/${userId}/sync/companies`,
      {}
    );
    if (Array.isArray(response.sync_target_companies)) {
      const companies: ICompanyState[] = [];
      response.sync_target_companies.forEach((company: any) => {
        if (
          company.sync_target_id &&
          company.sync_target_group_id &&
          company.company_id &&
          company.company_name &&
          company.disp_sort
        ) {
          companies.push({
            sync_target_id: company.sync_target_id,
            sync_target_group_id: company.sync_target_group_id,
            company_id: company.company_id,
            company_name: company.company_name,
            disp_sort: company.disp_sort,
          });
        }
      });
      this.set(companies);
    }
  }
}
